import React, { useState, useEffect } from "react";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import bootstrap from "@fullcalendar/bootstrap";
import timeGrid from "@fullcalendar/timegrid";
import calenderList from "@fullcalendar/list";
import interaction from "@fullcalendar/interaction";
import { FaCheck, FaDotCircle } from "react-icons/fa";
import { bgcolor, style } from "@mui/system";
import { Typography } from "@mui/material";
import { Calender } from "../../components/Calender/Calender";
import apiClient from "../../api/apiClient";
import { toast } from "react-toastify";
const events = [
  // { title: 'Meeting', start: new Date() },
  // ,
  {
    // this object will be "parsed" into an Event Object
    title: "The Title", // a property!
    start: "2023-02-18", // a property!
    end: "2023-02-25",
    editable: true,
    durationEditable: true, // a property! ** see important note below about 'end' **
  },
];

export default () => {
  const keyss=[
    {
    img:'require("../../assets/img/camera-icon.png")',
    value:"Install"
  },
    {
    img:'require("../../assets/img/video-icon.png")',
    value:"Removal"
  },]
  const [data, setData] = useState();
  function handleDateClick(date,events){
    setData({date,events})
  }
  const [submitData, setSubmitData] = useState();

  const handleChange = (key, value) => {
    setSubmitData({
      ...submitData,
      [key]: value,
    });
  };
  const handleEventsChange = async (events) => {
    const eventObjects = events.map((event) => ({
      color: event.color,
      date_time: event.date,
      title: event.title,
    }));
    setSubmitData({
      ...submitData,
      events: eventObjects,
    });
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    if (submitData?.campaign_type) {
      apiClient.post("/installerSchedule", submitData);
    }
  };
  return (
    <div>
      <form onSubmit={handleSubmit}>
        <div className="text-end">
          {/* <div className="dropdown">
          <button className="btn btn_bg shadow-none " type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
            Vehicle
          </button>
          <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
            <li><a className="dropdown-item text-primary " href="#">Isuzu, N-Series</a></li>
            <li><a className="dropdown-item text-primary " href="#">  Hino 155</a></li>
            <li><a className="dropdown-item text-primary " href="#">Freightliner</a></li>
          </ul>
        </div> */}
          <div className="dropdown mb-2 ">
            <button
              className="btn btn_bg shadow-none dropdown-toggle "
              type="button"
              id="dropdownMenuButton1"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              Campaign
            </button>
            <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
              <li
                className="px-2 py-2"
                style={{ display: "flex", alignItems: "center" }}
                onClick={() => handleChange("campaign_type", "NetFlix")}
              >
                <div style={{ width: "4rem" }}>
                  <img
                    style={{ width: "100%" }}
                    src={require("../../assets/img/netflix-img.png")}
                    alt=""
                  />
                </div>
                <a className="dropdown-item  fw-bold"    style={{color:"#005E9D"}}>
                  -NetFlix
                </a>
              </li>
              <li
                className="px-2 py-2"
                style={{ display: "flex", alignItems: "center" }}
                onClick={() => handleChange("campaign_type", "Addidas")}
              >
                <div style={{ width: "4rem" }}>
                  <img
                    style={{ width: "100%" }}
                    src={require("../../assets/img/adidas-img.png")}
                    alt=""
                  />
                </div>
                <a
                  className="dropdown-item  fw-bold"
                  href="#"
                  style={{color:"#005E9D"}}
                >
                  {" "}
                  -Addidas
                </a>
              </li>
              <li
                className="px-2 py-2"
                style={{ display: "flex", alignItems: "center" }}
                onClick={() => handleChange("campaign_type", "Disney")}
              >
                <div style={{ width: "4rem" }}>
                  <img
                    width={"100%"}
                    src={require("../../assets/img/disnep-img.png")}
                    alt=""
                  />
                </div>

                <a
                  className="dropdown-item  fw-bold "
                  style={{color:"#005E9D"}}
                >
                  -Disney
                </a>
              </li>
            </ul>
          </div>
        </div>
        <Calender keyss={keyss} handleDateClick={handleDateClick} />
        <div className="row gap-1 mt-2">
          <div className="col-md-7 border p-2">
          <h5 className="text_color ">{data?.date}</h5>
            <hr className="hr_design mt-0" />
            {!(data?.events.length==0)?<>
            {data?.events?.map((event)=>{
              let imageSrc = "";
              if (event.title === "Install") {
                imageSrc = require("../../assets/img/schedule-job-icon.png");
              } else if (event.title === "Removal") {
                imageSrc = require("../../assets/img/schedule-x-icon.PNG");
              }
                 return (
            <div className="d-flex gap-2 align-item-center flex-column flex-md-row">
              <div style={{ width: "1rem" }}>
                  <img
                    width="100%"
                    src={imageSrc}
                    alt=""
                  />
              </div>
             
              <span>
                - {event.title} at {event.time} <br />- Address: {event.address}
                
              </span>
            </div>)
                })}</>:"No Event"}
            {/* <div className="d-flex gap-2 align-item-center flex-column flex-md-row mt-2">
              <div style={{ width: "1rem" }}>
                <img
                  width="100%"
                  src={require("../../assets/img/schedule-x-icon.PNG")}
                  alt=""
                />
              </div>
              <span>
                - PhotoShoot in front of Moda Center after Swram at 5:30pm.{" "}
                <br />- Address: 321 Moda Rd., Portland, OR
              </span>
            </div> */}
          </div>
          <div className="col-md-4 border ">
            <div className="d-flex gap-1  px-2">
              <div>
                <h5 className="text_color">Key</h5>
                {/* <hr className='hr_design_2 mt-0' /> */}
              </div>
              <div className="mt-3 ">
                {/* <p className='text_color text_color d-flex align-items-center gap-1'>
        <FaDotCircle color='#00D030'/>
          Campain start
        </p>

        <p className='text_color d-flex align-items-center gap-1'>
        <FaDotCircle color='#F20000'/>
          Campain End
        </p> */}

                <p className=" text_color d-flex align-items-center gap-1">
                  <div style={{ width: "1rem" }}>
                    <img
                      width="100%"
                      src={require("../../assets/img/schedule-job-icon.png")}
                      alt=""
                    />
                  </div>
                  Install
                </p>

                <p className="text_color d-flex align-items-center gap-1">
                  <div style={{ width: "1rem" }}>
                    <img
                      width="100%"
                      src={require("../../assets/img/schedule-x-icon.PNG")}
                      alt=""
                    />
                  </div>
                  Removal
                </p>
                {/* <p className='text_color text_color d-flex align-items-center gap-1'>
        <div style={{width:'1rem'}}>
          <img width="100%" src={require("../../assets/img/retargeting.png")} alt="" />
          </div>
          Retargeting
        </p>
        <p className='text_color text_color d-flex align-items-center gap-1'>
        <div style={{width:'1rem'}}>
          <img width="100%" src={require("../../assets/img/camera-icon.png")} alt="" />
          </div>
          Photoshop
        </p>
        <p className='text_color d-flex align-items-center gap-1'>
        <div style={{width:'1rem'}}>
          <img width="100%" src={require("../../assets/img/bee.png")} alt="" />
          </div>
          Swarm
        </p> */}
                {/* <p className='text_color d-flex align-items-center gap-1'>
        <div style={{width:'1rem'}}>
          <img width="100%" src={require("../../assets/img/brush.png")} alt="" />
          </div>
          Creative
        </p>
        <p className='text_color d-flex align-items-center gap-1'>
        <div style={{width:'1rem'}}>
          <img width="100%" src={require("../../assets/img/new-report.png")} alt="" />
          </div>
          New Report
        </p> */}
              </div>
            </div>
            <div className="p-3" style={{ borderRadius: "10px ",backgroundColor:"#005E9D"}}>
              <Typography
                fontSize={16}
                color={"white"}
                textAlign={"center"}
              >
                View current jobs to see individual dates & futher detail
              </Typography>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col text-center mt-5 save-main">
            <button type="submit" className="btn_bgnone btn blue-clr">
              <span className="pe-2">Save Changes</span>
              <FaCheck />
            </button>
          </div>
        </div>
      </form>
    </div>
  );
};
